module.exports = __webpack_public_path__ + "img/blue-cross-icon.ce46dad6.svg";